module.exports = "https://s81616.cdn.ngenix.net/home-frontend/_next/static/images/insuranceCard-cf175123aa0c38a2ea57932f8741b08e.png";